import type { Catalog } from "../../en";

/** Filipino: Channels (/w/:ws/agents/:agentId/channels) (mirrors en). */
export const channels: Catalog["deployKnowledge"]["channels"] = {
  title: "Mga Channel",
  subtitleBefore: "Kung saan maaabot ng mga tao ang",
  subtitleAfter: ". Iisang utak, bawat channel.",
  subtitleFallback: "Kung saan maaabot ng mga tao ang assistant na ito. Iisang utak, bawat channel.",
  channelAnalytics: "Analytics ng channel",
  connectMessenger: "Ikonekta ang Messenger",
  messengerConnected: "Nakakonekta ang Messenger",
  loadError: "Hindi ma-load ang mga channel.",
  emptyTitle: "Wala pang channel ang assistant na ito",
  emptyBody: "Lalabas dito ang mga channel kapag na-set up na ang assistant. Magsimula sa website widget.",
  emptyCta: "Buksan ang Widget Studio",
  kpi: {
    active: "Aktibong channel",
    activeOf: "sa {{count}} na available",
    conversations: "Mga usapan · 7 araw",
    deltaUp: "+{{value}}%",
    deltaDown: "{{value}}%",
    noDelta: "Walang naunang datos na maikukumpara",
    top: "Nangungunang channel",
    topShare: "{{pct}}% ng mga usapan",
    none: "—",
    noConversations: "Wala pang usapan",
    avgResponse: "Avg na unang sagot · 7 araw",
    avgResponseHint: "Sa lahat ng channel",
  },
  names: {
    widget: "Website widget",
    webapp: "Web app",
    mobile: "Mobile app",
    messenger: "Facebook Messenger",
    email: "Email inbox",
    api: "REST API",
    playground: "Playground",
    slack: "Slack",
    teams: "Microsoft Teams",
  },
  status: {
    active: "Nakakonekta",
    pending: "Hindi pa naka-set up",
    disconnected: "Hindi nakakonekta",
    error: "Kailangang tingnan",
    disabled: "Naka-off",
  },
  enable: "I-on ang {{channel}}",
  toggledOn: "Naka-on na ang {{channel}}",
  toggledOff: "Naka-off na ang {{channel}}",
  conversations7d: "usapan · 7a",
  emails7d: "email · 7a",
  widget: {
    domains_one: "{{count}} domain",
    domains_other: "{{count}} na domain",
    noDomains: "Wala pang pinapayagang domain",
    description: "Chat bubble sa iyong website. Sa Widget Studio itinatakda ang mga domain at itsura.",
    customize: "I-customize",
  },
  webapp: {
    description: "Buong-page na chat sa sarili nitong address — ibahagi ang link kahit saan.",
    domainNote: "Ang custom domain at SSL ay pinamamahalaan sa Settings → Domains.",
    domain: "Domain",
    open: "Buksan",
    openLabel: "Buksan ang web app sa bagong tab",
  },
  mobile: {
    description: "Ilagay ang assistant sa loob ng sarili mong iOS o Android app, gamit ang ilang linya ng code.",
    note: "Walang ida-download sa amin.",
    guide: "Gabay sa pag-install",
  },
  messenger: {
    descriptionOff: "Maraming tao ang unang nagme-message sa iyong Facebook Page. Hayaang sumagot ang assistant 24/7.",
    descriptionOn: "Sumasagot sa mga mensahe ng Page 24/7. Lumalabas ang mga handoff sa Inbox na may Messenger badge.",
    connectPage: "Ikonekta ang Facebook Page",
    disconnect: "Idiskonekta",
    estimate: "Sumasagot sa loob ng 24-oras na window ng Meta",
    redirecting: "Binubuksan ang Facebook…",
    dialogTitle: "Ikonekta ang Facebook Messenger",
    dialogBody: "Mag-log in gamit ang Facebook account na admin ng iyong Page. Hindi kami kailanman magpo-post para sa iyo.",
    stepLogin: "Mag-log in",
    stepPage: "Pumili ng Page",
    stepPermissions: "Mga pahintulot",
    permissionsIntro: "Hihingin ng Sagot ang mga pahintulot na ito:",
    permMessaging: "Magbasa at sumagot sa mga usapan sa Messenger",
    permMetadata: "Mag-subscribe sa webhook ng mga bagong mensahe",
    permList: "Makita ang mga Page na pinamamahalaan mo",
    permBusiness: "Opsyonal: isama rin ang mga Page na pinamamahalaan mo sa pamamagitan ng business portfolio",
    pauseNote: "Puwede pa ring sumagot ang staff mula sa Meta Business Suite. Kapag sumagot ang staff, hihinto ang assistant sa usapang iyon nang 12 oras.",
    continueWithFacebook: "Magpatuloy gamit ang Facebook",
    redirectNote: "Aalis ka sa page na ito para mag-sign in sa Facebook, saka babalik dito para pumili ng Page.",
    disconnectTitle: "Idiskonekta ang Messenger?",
    disconnectBody: "Hihinto ang assistant sa pagsagot sa {{page}}. Mapupunta ang mga mensahe sa inbox ng Page lamang. Puwede kang kumonekta muli anumang oras.",
    disconnectConfirm: "Idiskonekta ang Messenger",
    disconnected: "Nadiskonekta ang Messenger",
    thisPage: "iyong Page",
  },
  email: {
    description: "I-forward dito ang iyong mailbox. Gumagawa ang assistant ng draft para i-review ng staff, o awtomatikong sumasagot sa mga simpleng tanong.",
    inboundLabel: "Inbound na address",
    copyInbound: "Kopyahin ang inbound na address",
    copied: "Nakopya ang inbound na address",
    replyMode: "Paraan ng pagsagot sa email",
    modeDraft: "Draft para i-review",
    modeAuto: "Awtomatikong sagot",
    modeSaved: "Paraan ng email: {{mode}}",
    setUp: "I-set up ang inbox",
    settings: "Settings ng inbox",
    settingsTitle: "Email inbox",
    settingsBody: "Gagawa kami ng inbound na address para sa assistant na ito. I-forward dito ang iyong mailbox.",
    forwarding: "Iyong mailbox",
    forwardingHint: "Ipinapakita sa staff para malaman nila kung aling mailbox ang nagfo-forward dito.",
    forwardingPlaceholder: "hal. hello@example.com",
    forwardingInvalid: "Maglagay ng wastong email address",
    save: "I-save ang inbox",
    saved: "Na-save ang email inbox",
  },
  api: {
    keys_one: "{{count}} aktibong key",
    keys_other: "{{count}} na aktibong key",
    noKeys: "Wala pang key",
    description: "Gumawa ng sariling interface. Dumarating ang mga sagot bilang JSON na may citations, o bilang Server-Sent Events.",
    keysLink: "Mga API key",
  },
  webhooks: {
    title: "Webhooks",
    endpoints_one: "{{count}} endpoint",
    endpoints_other: "{{count}} na endpoint",
    none: "Walang endpoint",
    description: "Ipadala ang mga event gaya ng bagong lead at handoff sa sarili mong mga sistema.",
    manage: "Pamahalaan",
  },
  comingSoon: {
    badge: "Malapit na",
    viber: "Viber",
    viberBody: "Viber Business Messages para sa mga mas gusto ang Viber.",
    note: "Ipapaalam namin sa console kapag inilunsad na ang mga ito.",
  },
  performance: {
    title: "Performance ng channel",
    period: "{{start}} – {{end}} · {{agent}}",
    range: "Saklaw ng performance",
    days7: "7 araw",
    days30: "30 araw",
    colChannel: "Channel",
    colConversations: "Mga usapan",
    colResolution: "Resolution rate",
    colResponse: "Avg na sagot",
    colCsat: "CSAT",
    resolutionLabel: "Resolution rate ng {{channel}}",
    emptyTitle: "Wala pang aktibidad sa channel",
    emptyBody: "Mag-on ng channel at ibahagi ito — lalabas ang performance pagkatapos ng mga unang usapan.",
    loadError: "Hindi ma-load ang performance ng channel.",
    noAccess: "Kailangan mo ng analytics access para makita ang performance ng channel.",
  },
  errors: {
    notConfigured: "Hindi pa naka-configure ang Facebook sign-in sa platform na ito. Makipag-ugnayan sa support.",
  },
};
